import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import NewsletterHeader from './NewsletterHeader';
import AdminHeader from './AdminHeader';
import UserUpdatesHeader from './UserUpdatesHeader';
import * as Date from '../utils/date';

const Wrapper = ({
  children,
  location,
  t,
  nextUpdate,
  daysToNextUpdate,
  shouldPromptConfirm,
  isConfirmed,
  isDueDatePassed,
}) => (
  <React.Fragment>
    <Header
      nextUpdate={nextUpdate}
      daysToNextUpdate={daysToNextUpdate}
      shouldPromptConfirm={shouldPromptConfirm}
    />
    {/* Actually, there could be a better place / way for this one */}
    {/* ... but I couldn't find :-) */}
    {location.pathname === '/home' && (
      <NewsletterHeader
        title={t('home.title')}
        subtitle={t('home.subtitle')}
        message={t('home.message', { comingIn: nextUpdate })}
        nextUpdate={nextUpdate}
        daysToNextUpdate={daysToNextUpdate}
      />
    )}

    {location.pathname === '/newsletters' && (
      <NewsletterHeader
        title={t('newsletter.archieveTitle')}
        subtitle={t('newsletter.archieveSubtitle')}
        nextUpdate={nextUpdate}
        daysToNextUpdate={daysToNextUpdate}
      />
    )}

    {['/admin/invites', '/admin/settings'].includes(location.pathname) && (
      <AdminHeader
        title={t('admin.adminTitle')}
        subtitle={t('admin.adminSubtitle')}
        nextUpdate={nextUpdate}
        daysToNextUpdate={daysToNextUpdate}
        isDueDatePassed={isDueDatePassed}
      />
    )}

    {['/updates', '/updates/last'].includes(location.pathname) && (
      <UserUpdatesHeader
        title={t('manageUpdates.title')}
        subtitle={t('manageUpdates.subtitle')}
        nextUpdate={nextUpdate}
        daysToNextUpdate={daysToNextUpdate}
        shouldPromptConfirm={shouldPromptConfirm}
      />
    )}

    {['/updates/confirm'].includes(location.pathname) && (
      <UserUpdatesHeader
        title={
          isConfirmed
            ? t('manageUpdates.titleConfirmed')
            : t('manageUpdates.titleConfirm')
        }
        subtitle={
          isConfirmed
            ? t('manageUpdates.subtitleConfirmed')
            : t('manageUpdates.subtitleConfirm')
        }
        nextUpdate={nextUpdate}
        daysToNextUpdate={daysToNextUpdate}
        shouldPromptConfirm={shouldPromptConfirm}
      />
    )}

    <div className="content content--main">
      <div className="o-wrapper o-wrapper--small o-wrapper--vertical">
        {children}
      </div>
    </div>

    <Footer />
  </React.Fragment>
);

const mapStateToProps = ({ workspace, user }) => {
  const daysToNextUpdate = Date.getDaysToDate(workspace.data.nextUpdate);
  const upToDateConfirmedAt = user.data && user.data.upToDateConfirmedAt;
  const shouldPromptConfirm =
    daysToNextUpdate < 8 &&
    (!upToDateConfirmedAt || Date.isOlderThanDays(upToDateConfirmedAt, 8));
  const isConfirmed =
    upToDateConfirmedAt && !Date.isOlderThanDays(upToDateConfirmedAt, 8);

  return {
    nextUpdate: Date.getHumanizedRemainingTimeTo(workspace.data.nextUpdate),
    daysToNextUpdate,
    shouldPromptConfirm,
    isConfirmed,
    isDueDatePassed:
      workspace.data &&
      workspace.data.status &&
      workspace.data.status.isDueDatePassed,
  };
};

export default withRouter(connect(mapStateToProps)(translate()(Wrapper)));



// WEBPACK FOOTER //
// ./src/common/Wrapper.js